import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { createSelector } from "@reduxjs/toolkit";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFetchTagsQuery } from "./tagsApi";
import { TagEntityType } from "./types";
import { insAssetsStateId, insFundsStateId, insInvestorsStateId, insManagersStateId, insPortfoliosStateId } from "common/constants";
import { ModalName } from "components/modal/types";
import { language } from "language/default";
import { openModal } from "store/modal";
const selectedRowsSelector = createSelector((state, stateId) => state.grids.state[stateId]?.selectedRows, (selectedRows) => selectedRows ?? []);
const openTagsModal = (dispatch, dataTags, stateId, entityType) => {
    const modalId = dataTags && dataTags.tags && dataTags.tags?.length > 0 ? "assign-tags" : "create-tag";
    const modalName = dataTags && dataTags.tags && dataTags.tags?.length > 0 ? ModalName.AssignTags : ModalName.CreateTag;
    dispatch(openModal({
        content: {
            id: modalId,
            modalName,
            parameters: {
                entityType,
                stateId
            }
        },
        title: language.en.modal.portfolioCreation.portfolioTagCreation.assignTagActionHeader,
        type: "action"
    }));
};
const getStateId = (entityType) => {
    switch (entityType) {
        case TagEntityType.PORTFOLIO:
            return insPortfoliosStateId;
        case TagEntityType.FUND:
            return insFundsStateId;
        case TagEntityType.MANAGER:
            return insManagersStateId;
        case TagEntityType.ASSET:
            return insAssetsStateId;
        case TagEntityType.INVESTOR:
            return insInvestorsStateId;
        default:
            return "";
    }
};
const InsAssignTagsButton = (props) => {
    const dispatch = useDispatch();
    const stateId = getStateId(props.entityType);
    const selectedRows = useSelector((state) => selectedRowsSelector(state, stateId));
    const { data: dataTags } = useFetchTagsQuery({ entityType: props.entityType });
    return React.createElement(AuxButton, { label: language.en.modal.portfolioCreation.portfolioTagCreation.assignTagAction, isDisabled: !selectedRows.length, size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.TERTIARY, onClick: () => openTagsModal(dispatch, dataTags, stateId, props.entityType) });
};
export default InsAssignTagsButton;
